import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { medicareApiClient } from 'clients/medicareApiClient'
import { PreventiveService } from '@cms-max/medicare-api-sdk'
import i18nInstance from 'i18n/config'
import { logAriaMessage } from 'redux/reducers/aria-log'

export enum Status {
  IDLE = 'idle',
  LOADING = 'loading',
  ERROR = 'error',
  FINISHED = 'finished'
}

interface IPreventiveServicesReducer {
  preventiveServicesList: PreventiveService[],
  status: Status
}

interface IPreventiveServicesSelectorState {
  preventiveServices: IPreventiveServicesReducer
}

const initialState: IPreventiveServicesReducer = {
  preventiveServicesList: [],
  status: Status.IDLE
}

export const getPreventiveServicesList = (state: IPreventiveServicesSelectorState) => state.preventiveServices.preventiveServicesList
export const getStatus = (state: IPreventiveServicesSelectorState) => state.preventiveServices.status

export const getPreventiveServices = createAsyncThunk(
  'preventive-services/getPreventiveServices',
  async (_, { dispatch }) => {
    const response = await medicareApiClient.asyncGetPreventiveServices()
    if (response) {
      dispatch(logAriaMessage(i18nInstance.t('Preventive services found', { ns: 'getPreventiveServices' })))
      return response
    } else {
      dispatch(logAriaMessage(i18nInstance.t('Preventive services unavailable', { ns: 'getPreventiveServices' })))
      throw new Error('Error fetching preventive services')
    }
  }
)

export const preventiveServicesSlice = createSlice({
  name: 'PreventiveServices',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPreventiveServices.pending, (state: IPreventiveServicesReducer) => {
        state.status = Status.LOADING
      })
      .addCase(getPreventiveServices.fulfilled, (state: IPreventiveServicesReducer, { payload }) => {
        state.status = Status.FINISHED
        state.preventiveServicesList = payload.preventiveServices || []
      })
      .addCase(getPreventiveServices.rejected, (state: IPreventiveServicesReducer) => {
        state.status = Status.ERROR
      })
  }
})

export default preventiveServicesSlice.reducer
